import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Integrations from "./pages/Integrations";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import AboutUs from "./pages/AboutUs";
import Careers from "./pages/Careers";
import FeaturesPage from "./pages/Features";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import AdminBlog from "./pages/AdminBlog";
import AdminJobs from "./pages/AdminJobs";
import FreeTrial from "./pages/FreeTrial";
import JobDetail from "./pages/JobDetail";
import Ecommerce from "./pages/solutions/Ecommerce";
import Manufacturing from "./pages/solutions/Manufacturing";
import Wholesale from "./pages/solutions/Wholesale";
import Fashion from "./pages/solutions/Fashion";
import AkeneoComparison from "./pages/competitors/AkeneoComparison";
import PimberlyComparison from "./pages/competitors/PimberlyComparison";
import SalesLayerComparison from "./pages/competitors/SalesLayerComparison";
import SalsifyComparison from "./pages/competitors/SalsifyComparison";
import UltraCommerceComparison from "./pages/competitors/UltraCommerceComparison";
import Support from "./pages/Support";
import NotFound from "./pages/NotFound";
import Product360Landing from "./pages/Product360Landing";
import RetailTechStack2026 from "./pages/RetailTechStack2026";
import ShopifyIntegration from "./pages/integrations/ShopifyIntegration";
import GoogleShopping from "./pages/integrations/GoogleShopping";
import AdminIntegrations from "./pages/AdminIntegrations";
import Roadmap from "./pages/Roadmap";
import AdminRoadmap from "./pages/AdminRoadmap";
import OmmniFlow from "./pages/features/OmmniFlow";
import PIM from "./pages/features/PIM";
import DAM from "./pages/features/DAM";
import DOM from "./pages/features/DOM";
import Offers from "./pages/features/Offers";
import InventoryFeature from "./pages/features/Inventory";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import SEOHealthCheck from "./pages/SEOHealthCheck";
import Sitemap from "./pages/Sitemap";
import ApplicationThankYou from "./pages/ApplicationThankYou";
import ScrollToTop from "./components/ScrollToTop";
import Breadcrumbs from "./components/Breadcrumbs";
import { CookieConsent } from "./components/CookieConsent";
import { PageViewTracker } from "./components/PageViewTracker";
import { HubSpotTracking } from "./components/HubSpotTracking";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <CookieConsent />
      <BrowserRouter>
        <PageViewTracker />
        <HubSpotTracking />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/team" element={<Team />} /> */}
          <Route path="/about" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/admin/jobs" element={<AdminJobs />} />
          <Route path="/admin/integrations" element={<AdminIntegrations />} />
          <Route path="/careers/:id" element={<JobDetail />} />
          <Route path="/solutions/ecommerce" element={<Ecommerce />} />
          <Route path="/solutions/manufacturing" element={<Manufacturing />} />
          <Route path="/solutions/wholesale" element={<Wholesale />} />
          <Route path="/solutions/fashion" element={<Fashion />} />
          <Route path="/free-trial" element={<FreeTrial />} />
          <Route path="/competitors/akeneo" element={<AkeneoComparison />} />
          <Route path="/competitors/pimberly" element={<PimberlyComparison />} />
          <Route path="/competitors/sales-layer" element={<SalesLayerComparison />} />
          <Route path="/competitors/salsify" element={<SalsifyComparison />} />
          <Route path="/competitors/ultra-commerce" element={<UltraCommerceComparison />} />
          <Route path="/support" element={<Support />} />
          <Route path="/integrations/shopify" element={<ShopifyIntegration />} />
          <Route path="/integrations/google-shopping" element={<GoogleShopping />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/admin/roadmap" element={<AdminRoadmap />} />
          <Route path="/features/ommni-flow" element={<OmmniFlow />} />
          <Route path="/features/pim" element={<PIM />} />
          <Route path="/features/dam" element={<DAM />} />
          <Route path="/features/dom" element={<DOM />} />
          <Route path="/features/offers" element={<Offers />} />
          <Route path="/features/inventory" element={<InventoryFeature />} />
          <Route path="/product360" element={<Product360Landing />} />
          <Route path="/retail-tech-stack-2026" element={<RetailTechStack2026 />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/seo-health-check" element={<SEOHealthCheck />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/application-thank-you" element={<ApplicationThankYou />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
